import { render, staticRenderFns } from "./px-counter.vue?vue&type=template&id=73ff4be4&scoped=true&"
import script from "./px-counter.vue?vue&type=script&lang=ts&"
export * from "./px-counter.vue?vue&type=script&lang=ts&"
import style0 from "./px-counter.vue?vue&type=style&index=0&id=73ff4be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ff4be4",
  null
  
)

export default component.exports